import React     from 'react';
import PropTypes from 'prop-types';

function Tag({tag, onClickTag, showClose, isActive, activeFilter}) {
    if(tag.hidden) {
        return null;
    }

    const getText = () => {
        if (tag.texts) {
            const texts = activeFilter && activeFilter.find(item => item.key && tag.texts[item.key] && tag.texts[item.key][item.value.KEY]);
            if(texts && texts.key) {
                return tag.texts[texts.key][texts.value.KEY];
            }
        }
        return tag.text;
    };

    return <div className={'filter__tag-item' + (tag.isActive ? " filter__tag-item--active" : "")} onClick={ () => onClickTag(tag)}>
        {tag.color && <span className={'filter__tag-item__color filter__tag-item__color--' + tag.color}> </span>}
        {tag.categoryShort && isActive ? tag.categoryShort : getText()}
        {showClose && <i className={'icon -icon-close-line filter__tag-item__close'} />}
    </div>;
}

Tag.propTypes = {
    tag:          PropTypes.object.isRequired,
    onClickTag:   PropTypes.func.isRequired,
    showClose:    PropTypes.bool,
    isActive:     PropTypes.bool,
    activeFilter: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

Tag.defaultProps = {
    showClose: false,
    isActive:  false,
};

export default Tag;
